export async function acceptInvite(inviteCode: string) {
  try {
    const response = await fetch("/invites/accept", {
      method: "POST",
      body: JSON.stringify({ inviteCode }),
      headers: {
        "content-type": "application/json",
      },
    });
    if (response.ok) {
      const res = await response.json();
      if (res.errors) {
        return { errors: res.errors };
      }
      return { message: res.data.acceptInvite.message };
    }
    return { message: undefined, errors: response.statusText };
  } catch (err) {
    console.error(err);
    return { message: undefined, errors: err };
  }
}

export async function rejectInvite(inviteCode: string) {
  try {
    const response = await fetch("/invites/reject", {
      method: "POST",
      body: JSON.stringify({ inviteCode }),
      headers: {
        "content-type": "application/json",
      },
    });
    if (response.ok) {
      const res = await response.json();
      if (res.errors) {
        return { errors: res.errors };
      }
      return { message: res.data.rejectInvite.message };
    }
    return { message: undefined, errors: response.statusText };
  } catch (err) {
    console.error(err);
    return { message: undefined, errors: err };
  }
}

export async function resendInvite(invitedPartyId: string, teamId: string) {
  try {
    const response = await fetch("/invites/resend", {
      method: "POST",
      body: JSON.stringify({ invitedPartyId, teamId }),
      headers: {
        "content-type": "application/json",
      },
    });
    if (response.ok) {
      const res = await response.json();
      if (res.errors) {
        return { errors: res.errors };
      }
      return { message: res.data.resendInvite.message };
    }
    return { message: undefined, errors: response.statusText };
  } catch (err) {
    console.error(err);
    return { message: undefined, errors: err };
  }
}

export async function confirmInviteCode(inviteCode: string) {
  try {
    const response = await fetch("/invites/verify", {
      method: "POST",
      body: JSON.stringify({ inviteCode }),
      headers: {
        "content-type": "application/json",
      },
    });
    if (response.ok) {
      const res = await response.json();
      if (res.errors) {
        return { errors: res.errors };
      }
      return { invite: res.data.invites[0] };
    }
    return { invite: undefined, errors: response.statusText };
  } catch (err) {
    console.error(err);
    return { invite: undefined, errors: err };
  }
}